import Vue from 'vue';
import App from './App.vue';
import router from './router';
import api from "./api/api"
import ajax from "./api/index"
import store from './store/index'

import 'mint-ui/lib/style.css'
import {Swipe, SwipeItem, Toast, Indicator, Loadmore, MessageBox} from 'mint-ui';

Vue.config.productionTip = false;
Vue.prototype.$api = api;
Vue.prototype.$ajax = ajax;

Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
Vue.component(Loadmore.name, Loadmore);
// Vue.component(Indicator.name, Indicator);



new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
